import { render, staticRenderFns } from "./CmsBanners.vue?vue&type=template&id=13725f70&scoped=true"
import script from "./CmsBanners.vue?vue&type=script&lang=js"
export * from "./CmsBanners.vue?vue&type=script&lang=js"
import style0 from "./CmsBanners.vue?vue&type=style&index=0&id=13725f70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13725f70",
  null
  
)

export default component.exports